// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"14dae85e","453":"64512fd7","455":"8cb703f8","762":"f80d65c0","977":"826695ee"}[chunkId] + ".chunk.js";
};